import { useMutation, useQueryClient } from "@tanstack/react-query"

import { removeFileApi } from "@/api/api"
import { queryKeys } from "@/lib/query-keys"

type RemoveIndexedFileVariables = {
  sessionId: string
  fileName: string
  token: string | undefined
}

export function useRemoveIndexedFileMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: queryKeys.removeIndexedFile,
    mutationFn: async ({ sessionId, fileName, token }: RemoveIndexedFileVariables) => {
      return await removeFileApi(sessionId, fileName, token)
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.indexedFiles(variables.sessionId) })
    },
  })
}
